import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthenticationService } from '../../../../src/app/shared/services/authentication.service';
import { NotificationService } from '../../../../src/app/shared/services/notification.service';
import { environment } from '../environments/environment';
import { EnvironmentService } from '../../../../src/app/services/environment.service';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>'
})

export class AppComponent implements OnInit {

  constructor(private router: Router,
              public authenticationService: AuthenticationService,
              private notificationService: NotificationService,
              private environmentService: EnvironmentService
    ) { }

  ngOnInit() {
    this.environmentService.setEnvironment(environment);

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });


  }

//  logout() {
//    this.authenticationService.logout();
//    this.notificationService.stop();
//    this.router.navigate(['/login']);
//}
}
